var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Tabs as ChakraTabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
export const Tabs = (props) => {
    const { tabList, defaultActiveTab = 0, variant = "enclosed", onChange = () => { } } = props, rest = __rest(props, ["tabList", "defaultActiveTab", "variant", "onChange"]);
    const [tabIndex, setTabIndex] = useState(defaultActiveTab);
    useEffect(() => {
        setTabIndex(defaultActiveTab);
    }, [defaultActiveTab]);
    const handleTabsChange = (index) => {
        setTabIndex(index);
        onChange(index);
    };
    return (_jsxs(ChakraTabs, Object.assign({ variant: variant, index: tabIndex, onChange: handleTabsChange, isLazy: true }, rest, { children: [_jsx(TabList, { children: tabList.map((tab, index) => {
                    const { label: Label } = tab;
                    return (_jsx(Tab, { children: _jsx(Label, {}) }, index));
                }) }), _jsx(TabPanels, { children: tabList.map((tab, index) => {
                    const { component: Component } = tab, relatedProps = __rest(tab, ["component"]);
                    return (_jsx(TabPanel, { p: "0px", children: _jsx(Component, { handleTabsChange: handleTabsChange, rest: relatedProps }) }, index));
                }) })] })));
};
//# sourceMappingURL=tabs.js.map